// Keep the Console launcher's HELP_APP_RELEASE in sync. Its contract test
// compares that value with this build-owned marker.
export const HELP_APP_RELEASE = 'help-20260807.1';
